module.exports = {"431302001":"乐坪街道","431302002":"花山街道","431302003":"黄泥塘街道","431302004":"长青街道","431302005":"大科街道","431302006":"涟滨街道","431302007":"大埠桥街道","431302100":"杉山镇","431302101":"万宝镇","431302104":"石井镇","431302105":"水洞底镇","431302106":"蛇形山镇","431302204":"双江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431302.json
// module id = 1930
// module chunks = 0